import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../../web/components-v2/Button';
import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { shadowSm } from '../../../web/styles/shadows';
import { FontFamilies } from '../../../web/styles/styles';
import { useCoffeeWhitePages } from '../../shell/useCoffeeWhitePages';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

const styleSheet = StyleSheet.create({
	page: {
		boxSizing: 'border-box',
		display: 'flex',
		minHeight: '100%',
		padding: SPACE[16],
		width: '100%',
	},
	pageWhite: {
		backgroundColor: THEME.colors.background.light,
		padding: 0,
	},
	card: {
		alignItems: 'center',
		backgroundColor: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		boxSizing: 'border-box',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: SPACE[16],
		justifyContent: 'center',
		padding: SPACE[48],
		textAlign: 'center',
	},
	cardFlat: {
		borderRadius: 0,
		boxShadow: 'none',
	},
	// The display numerals are the legacy Coffee 404 graphic, recoloured for the light page.
	graphic: {
		color: THEME.colors.primary.main,
		fontFamily: FontFamilies.conqueror,
		fontSize: 260,
		lineHeight: 1,
		[THEME.queries.sm]: {
			fontSize: 160,
		},
	},
	title: {
		color: THEME.colors.text.main,
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.xl,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	subtitle: {
		color: THEME.colors.text.light,
		fontSize: fontSizes.sm,
		margin: 0,
	},
});

export const PageNotFound: React.FC = () => {
	const [whitePages] = useCoffeeWhitePages();
	return (
		<div className={css(styleSheet.page, whitePages && styleSheet.pageWhite)}>
			<div className={css(styleSheet.card, whitePages && styleSheet.cardFlat)}>
				<div className={css(styleSheet.graphic)} aria-hidden='true'>
					404
				</div>
				<h1 className={css(styleSheet.title)}>Page not found</h1>
				<p className={css(styleSheet.subtitle)}>We couldn’t find the page you were looking for.</p>
				<Button asChild variant='primary'>
					<Link to='/'>Back to Queue</Link>
				</Button>
			</div>
		</div>
	);
};
